<template>
  <div class="header">
    <ul>
      <li class="headerList">
        <a :href="homeUrl" target="home">
          <v-icon>mdi-home</v-icon>
        </a>
      </li>
<!--      <li class="headerList">-->
<!--        <v-icon @click="createHypermeeting">mdi-message-video</v-icon>-->
<!--      </li>-->
<!--      <li class="headerList">-->
<!--        <v-icon @click="hyperMeetingJoin">mdi-message</v-icon>-->
<!--      </li>-->
      <li class="headerList" v-if="settingAllowed">
        <v-icon @click="$router.push('/site')">mdi-settings</v-icon>
      </li>
      <li class="headerList">
        <v-btn small color="#fb8c00" depressed @click="logout()">로그아웃</v-btn>
      </li>
    </ul>


  </div>
</template>

<script>
// import hyperMeetingApi from "@/api/HyperMeetingApi";
export default {
  name: "Header",
  components: {},
  data: () => ({
    homeUrl: process.env.VUE_APP_HOME,
    hypermeeting: {},
    settingAllowed: false
  }),
  methods: {
    logout() {
      this.$store.dispatch('user/logout');
      this.$router.push('/login');
    },
    // hyperMeetingJoin() {
    //   window.open(`${process.env.VUE_APP_HYPER_MEETING}/meeting/${this.hypermeeting.roomId}?userId=test&userName=테스트`, 'hm2');

      // hyperMeetingApi.get().then(roomResult => {
      //
      //       return hyperMeetingApi.exist(roomResult.roomId).then(() => {
      //         window.open(`${process.env.VUE_APP_HYPER_MEETING}/meeting/${roomResult.roomId}?userId=test&userName=테스트`, 'hm2');
      //       }).catch(error=> {
      //           throw error;
      //       });
      //
      // }).catch(error=> {
      //   console.log(error.response);
      //   if(error.response.status === 404) {
      //     alert("생성된 화상 회의가 없습니다.");
      //   } else {
      //     alert(error.response.data.error)
      //   }
      // });
    // },
    // createHypermeeting() {
    //   const roomPayload = {
    //     roomName: 'e-club',
    //     roomCapacity: '100'
    //   }
    //   hyperMeetingApi.save(roomPayload).then(res => {
    //     this.hypermeeting = res.data;
    //     window.open(`${process.env.VUE_APP_HYPER_MEETING}/meeting/${this.hypermeeting.roomId}?userId=${this.$store.state.user.userid}&userName=${this.$store.state.user.username}&leaderKey=${this.hypermeeting.leaderKey}`, 'hm');
    //   });
    //
    //   // hyperMeetingApi.get().then(roomResult => {
    //   //   // console.log(roomResult)
    //   //   return hyperMeetingApi.exist(roomResult.roomId).then(() => {
    //   //     window.open(`${process.env.VUE_APP_HYPER_MEETING}/meeting/${roomResult.roomId}?userId=${this.$store.state.user.userid}&userName=${this.$store.state.user.username}&leaderKey=${roomResult.leaderKey}`, 'hm');
    //   //   }).catch(error=> {
    //   //       throw error;
    //   //   });
    //   //
    //   // }).catch(error=> {
    //   //   hyperMeetingApi.deleteRoom().then(() => {
    //   //     if(error.response.status === 404) {
    //   //       this.hyperMeetingCreate(roomPayload);
    //   //     } else {
    //   //       alert(error.response.data);
    //   //       // console.log(error.response.data);
    //   //       // console.log(error.response);
    //   //     }
    //   //   });
    //   // });
    //
    // },
    // hyperMeetingCreate(roomPayload) {
    //   hyperMeetingApi.create(roomPayload).then(res => {
    //     hyperMeetingApi.registry(res.data.hmRoomID, res.data.leaderKey);
    //     window.open(`${process.env.VUE_APP_HYPER_MEETING}/meeting/${res.data.hmRoomID}?userId=${this.$store.state.user.userid}&userName=${this.$store.state.user.username}&leaderKey=${res.data.leaderKey}`, 'hm');
    //   });
    //
    // }
  },
  created() {
    const userMenus = JSON.parse(localStorage.getItem("userMenus"));
    // console.log(userMenus)
    // if(userMenus.some(m => m.href === '/site'))
    if(userMenus.some(m => m.id === 387))
      this.settingAllowed = true

    // console.log(this.$store.state.user)
    // console.log(this.$store.getters.userid)
    // console.log(this.$store.getters['user/userid'])
    // console.log(this.$store.getters)
    // console.log(process.env)
  }

}
</script>

<style lang="scss" scoped>
.header {
  height: 50px;
  background: #e5e5e5;

  ul {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    height: 100%;

    .headerList {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-right: 15px;
    }
  }
}
</style>
